














































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroPlayerDocument, VoteDocument } from "@/services/datatypes";
import { JinroRoles } from "../../services/jinro-roles";
import { DialogProgrammatic as Dialog } from "buefy";
import PlayerRowsSkelton from "./PlayerRowsSkelton.vue";
import { getPlayerIdVotedCountAssociativeList } from "../../utils/utils";

interface SelectOptionObj {
  id: string;
  name: string;
}

@Component({
  components: {
    PlayerRowsSkelton,
  },
})
export default class SelectList extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly selectablePlayers!: Array<JinroPlayerDocument>;
  @Prop() readonly selectLabel!: string;
  @Prop() readonly hasSubmited!: boolean;
  @Prop() readonly reselectable!: boolean;
  @Prop() readonly votes!: Array<VoteDocument>;
  @Prop() readonly skeltonRowNumber!: number;
  @Prop() readonly jinroNotAbleToVoteForJinro!: boolean;

  selectedOption: string | null = null;

  selectedDialogue() {
    Dialog.confirm({
      message: `<strong>${this.selectedPlayerName}</strong> を選びます。確定しますか？`,
      cancelText: "キャンセル",
      confirmText: "確定する",
      onCancel: () => (this.selectedOption = null),
      onConfirm: () => this.handleSubmit(),
    });
  }

  cancelSubmitDialogue() {
    Dialog.confirm({
      message: `選択を取り消しますか？`,
      cancelText: "キャンセル",
      type: "is-danger",
      confirmText: "選択を取り消し再度選択する",
      onConfirm: () => this.handleCancelSubmit(),
    });
  }

  handleCancelSubmit() {
    // 過去に投票したvoteの情報は消す
    this.$emit("cancel-submit");
  }

  get placeholder(): string {
    const text = this.hasSubmited ? "再度 リストから選ぶ" : "リストから選ぶ";
    return text;
  }

  get selectedPlayerName(): string {
    if (!this.isSelected) {
      return "";
    }
    const playerId = this.selectedOption;
    const player = this.selectablePlayers.find((player) => {
      return player.id === playerId;
    });
    if (!player || !player.playerName) {
      return "";
    }
    return player.playerName;
  }

  get isKilled(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      const that = this.$store.state.jinroPlayerGame;
      return !!that.isKilled;
    } else {
      return false;
    }
  }

  get isSelected(): boolean {
    return this.selectedOption !== null;
  }

  listDisable(playerId: string): boolean {
    return this.meDisable(playerId) || this.jinroDisable(playerId);
  }

  jinroDisable(playerId: string): boolean {
    const jinroIds = this.jinroIds();
    return jinroIds.includes(playerId) && this.jinroNotAbleToVoteForJinro;
  }

  meDisable(playerId: string): boolean {
    return playerId === this.$route.params.jinroPlayerId;
  }

  get selectOptions(): Array<SelectOptionObj> {
    const selectOptionsArray = this.selectOptionsArray;

    return selectOptionsArray;
  }

  get selectOptionsArray(): Array<{
    id: string;
    name: string;
    votedCount?: number;
  }> {
    const players = this.selectablePlayers;
    if (!players || players.length === 0) {
      return [];
    }

    let options = players;
    if (this.isPlayerJinro) {
      options = this.attachJinroInfo(options);
    }

    if (!this.votes) {
      return options.map((player: JinroPlayerDocument) => {
        return {
          id: player.id,
          name: player.playerName,
        };
      });
    }

    const PlayerIdToVotesCount = getPlayerIdVotedCountAssociativeList(
      this.votes
    );
    return options.map((player: JinroPlayerDocument) => {
      const votedCount = PlayerIdToVotesCount[player.id]
        ? PlayerIdToVotesCount[player.id]
        : 0;
      return {
        id: player.id,
        name: player.playerName,
        votedCount: votedCount,
      };
    });
  }

  async handleSubmit() {
    this.$emit("submited", this.selectedOption);
  }

  get isPlayerJinro(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.role === JinroRoles.Jinro;
    }
    return false;
  }

  jinroIds(): string[] {
    if (!this.isPlayerJinro) {
      return [];
    }
    const playersWithJinroRole: Array<JinroPlayerDocument> = this.$store.state
      .jinroPlayerGame.playersWithJinroRole;

    const jinroIds = playersWithJinroRole.map((player) => {
      return player.id;
    });
    return jinroIds;
  }

  attachJinroInfo(
    players: Array<JinroPlayerDocument>
  ): Array<JinroPlayerDocument> {
    const jinroIds = this.jinroIds();
    const arry = players.map((player) => {
      return jinroIds.includes(player.id)
        ? {
            ...player,
            playerName: player.playerName + " (人狼)",
          }
        : {
            ...player,
          };
    });

    return arry;
  }
}
